// src/lib/charte-voyageur.js
// Charte PUBLIC VOYAGEUR — GELÉE (ADR-149).
//
// Snapshot EXACT du DS au 2026-06-30, AVANT la refonte Direction Artistique (DA).
// La DA rhabille admin + ménage + proprio en mettant à jour `src/lib/ui.js` (DS).
// Le RENDU PUBLIC voyageur (livret d'accueil + ses briques, formulaires publics,
// page de paiement, parcours, services voyageur) reste sur la charte ADR-149 et
// NE doit PAS bouger : navy/sky/terracotta + Playfair Display + Raleway.
//
// Tous les composants de rendu voyageur importent ce `DSV` (et non `ui.js` DS).
// Décision Dimitri (chantier DA, 2026-06-30) : « voyageur dans un second temps ».
// Le site vitrine/réservation par logement vit dans le repo SÉPARÉ `fbz-sites`
// (consumer SSR/SSG de `api/sites.js`) — hors de ce repo, donc hors d'atteinte.
//
// ⚠️ NE PAS faire pointer ce fichier vers ui.js : il doit rester un snapshot
// autonome, gelé, indépendant des futures évolutions du DS admin.

export const DSV = {
  navy: "#215387",
  navyDark: "#1a3f66",
  navyLight: "#3a72a8",
  sky: "#87b8e6",
  skyDeep: "#0284c7",
  skyPastel: "#a8d8f0",
  terra: "#C17B5C",
  green: "#2d7a3a",
  amber: "#d97706",
  charge: "#e11d48",
  chargePastel: "#fda4af",
  red: "#c0392b",
  bg: "#f0f4f9",
  white: "#ffffff",
  border: "#e4eaf3",
  textLight: "#8fa3bc",
  fontDisplay: "'Playfair Display', serif",
  fontBody: "'Raleway', sans-serif",
}
